/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
import http from "@/http";
import axios from "@/http/customsAxios";
import returnUrlParams from "@/http/returnUrlParams";
import * as types from "./types";

const actions = {
  [types.GET_PRICE](context, { recipe, type = 'customizer' }) {
    if (!recipe) throw new Error("The recipe param is required");

    const requestUrl = `${this.state.endPoints[type].getPrice}`;

    if (context.state.requestedRecipe === JSON.stringify(recipe) || this.state.utils.isSplashModalOpen) {
      return Promise.resolve();
    }
    context.commit("SAVE_REQUESTED_RECIPE", JSON.stringify(recipe));
    return new Promise((resolve, reject) => {
      axios({
        url: requestUrl,
        method: "POST",
        headers: { "content-type": "application/json" },
        data: JSON.stringify(recipe)
      })
        .then(({ data }) => {
          context.commit("SET_PRICE", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  [types.GET_SKU](context, { recipe_id, locale, size, type = 'customizer' }) {
    if (!recipe_id) throw new Error("The recipe id param is required");

    const params = {};
    if (!this.state.utils.caid && locale) params.locale = locale;
    if (size) params.size = size; // optionally added

    const requestUrl = `${ this.state.endPoints[type].getSkuByRecipeId }${ recipe_id }`;

    return new Promise((resolve, reject) => {
      http
        .get(requestUrl, { params })
        .then(({ data }) => {
          context.commit(types.SET_SKU, data.sku);
          resolve(data);
        })
        .catch(reject);
    });
  },
  [types.ADD_TO_CART](context, { data, type = 'customizer' }) {
    const requestUrl = `${ this.state.endPoints[type].addToCart }?${ returnUrlParams(data) }`;

    return new Promise((resolve, reject) => {
      axios({
        url: requestUrl,
        method: "POST",
        headers: { "content-type": "application/json" },
        data: JSON.stringify(data)
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  [types.ADD_TO_WISHLIST](context, { data, type = 'customizer' }) {
    const requestUrl = `${ this.state.endPoints[type].favorites }?${ returnUrlParams(data) }`;

    return new Promise((resolve, reject) => {
      axios({
        url: requestUrl,
        method: "POST",
        headers: { "content-type": "application/json" },
        data: JSON.stringify(data)
      })
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  [types.GET_SIZE_GUIDE_MODAL_CONTENT]({ state }, sizeGuideUrl) {
    return new Promise((resolve, reject) => (
      http.get(sizeGuideUrl).then(({ data }) => resolve(data))
    ));
  },
  [types.ADD_TO_CART_CANVAS](context, {basketId, productId, quantity, pdpUrl, productImageURL, recipeId, locale}) {
    const requestUrl = `/api/cart/v1/item?locale=${locale}`
    return fetch(requestUrl, {
      method: "PUT",
      headers: this.state.utils.canvasAPIheaders,
      body: JSON.stringify([{
        "cartId": basketId,
        "productId": productId,
        "qty": quantity,
        "maxQty": 100,
        pdpUrl,
        productImageURL,
        recipeId
      }])
    })
  },
  [types.FETCH_BASKET_ID](context, {locale}){
    return fetch(`/api/cart/v1/cart?locale=${locale}`, {
      headers: this.state.utils.canvasAPIheaders,
      method: "POST",
      body: JSON.stringify({})
    });
  }
};

export default actions;
